import React, {useState, useEffect} from 'react';
import MenuAdmin from '../../../../components/layout/menu';
import TableList from '../../../../components/lists/visitList/index';
import SearchInput from '../../../../components/filters/searchInput';
import FilterInput from '../../../../components/filters/filterInput';
import FilterButton from '../../../../components/filters/filterButton';
import ResetFiltersButton from '../../../../components/filters/resetFiltersButton';
import ExportButton from '../../../../components/shared/exportButton';
import { getVisits } from "../../../../client/administration/list/index";
import { getEvents } from '../../../../client/administration/event';
import * as XLSX from 'xlsx';
import ContentLoader from 'react-content-loader';
import Programate from '../../../../components/layout/footer';
import Card from '../../../../screens/menu/board/index'; 

export default function List() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const [placa, setPlaca] = useState("");
  const [records, setRecords] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true); 
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [noRecords, setNoRecords] = useState(false);
  

  useEffect(() => {
    if (records.length > 0) {
      setFilteredRecords(records);
    }
  }, [records]);
  const [viewMode, setViewMode] = useState('list');
    const toggleViewMode = () => {
      setViewMode(viewMode === 'list' ? 'Card' : 'list');
    };

  useEffect(() => {
    const fetchVisits = async () => {
      try {
        const visitsResponse = await getVisits(); // Obtener las visitas
        const eventsResponse = await getEvents(); // Obtener los eventos
        const visitsData = visitsResponse.data;
        const eventsData = eventsResponse.data;

        //obtener el último estado del último registro 
        const latestEvents = eventsData.reduce((acc, event) => {
          if (!acc[event.idVisit] || new Date(event.dateOfEntry) > new Date(acc[event.idVisit].dateOfEntry)) {
            acc[event.idVisit] = event;
          }
          return acc;
        }, {});

        const eventIds = new Set(eventsData.map(event => event.idVisit));
        const isValidDate = (date) => date && !isNaN(new Date(date).getTime());

        const currentDate = new Date();
        const startOfNextDay = new Date(currentDate);
        startOfNextDay.setHours(24, 0, 0, 0); // Establecer a las 00:00 del día siguiente
    
        const updatedVisits = visitsData.map(visit => {
          let estado = "Agendado";
          let lastStateChange = isValidDate(visit.createdAt) ? new Date(visit.createdAt) : null; // Usar createdAt como lastStateChange por defecto

          //obtener registro con 10 min de retraso
          const finalDate = new Date(visit.finalDateScheduled);
          const tenMinutesLater = new Date(finalDate.getTime() + 10 * 60 * 1000);
          const currentTime = new Date();
  
          if (eventIds.has(visit.id)) {
            // Buscar el evento relacionado con la visita
            const matchingEvent = latestEvents[visit.id]; // Obtener el evento más reciente
  
            if (matchingEvent) {
              if (matchingEvent.ouputWeighting > 0) {
                // Estado: Salió
                estado = "Salió";
                lastStateChange = isValidDate(matchingEvent.departureDate)
                  ? new Date(matchingEvent.departureDate)
                  : lastStateChange;
              } else if (matchingEvent.inputWeighting > 0) {
                // Estado: Entró
                estado = "Entró";
                lastStateChange = isValidDate(matchingEvent.dateOfEntry)
                  ? new Date(matchingEvent.dateOfEntry)
                  : lastStateChange;
              }
            }
          } else if (currentTime > tenMinutesLater){
            estado = "Retraso";
          }
  
          return { ...visit, estado, lastStateChange };
        });
        const currentTime = new Date();


        const filteredVisits = updatedVisits.filter(visit => {
          const startDate = new Date(visit.startDateScheduled);
          const finalDate = new Date(visit.finalDateScheduled);
          const isToday = startDate.toDateString() === currentDate.toDateString();
          const isTomorrow = finalDate.toDateString() === startOfNextDay.toDateString();
          const isFinalDateTodayAndNotPassed = finalDate >= currentTime;
    
          // Nueva lógica para incluir visitas agendadas que están en retraso
          const isInDelayToday = finalDate.toDateString() === currentDate.toDateString() && currentTime < startOfNextDay;

          return (isToday || isTomorrow || (isFinalDateTodayAndNotPassed && finalDate.toDateString() === currentDate.toDateString()) || isInDelayToday);
        });

      //  console.log("Filtered Visits:", filteredVisits);
    
        // Ordenar todos los registros por lastStateChange
        const sortedVisits = filteredVisits.sort((a, b) => {
          const dateA = isValidDate(a.lastStateChange) ? new Date(a.lastStateChange) : 0;
          const dateB = isValidDate(b.lastStateChange) ? new Date(b.lastStateChange) : 0;
          return dateB - dateA; // Orden descendente por fecha
        });
  
       // console.log("Sorted Visits:", sortedVisits);
  
        // Actualizar el estado con los registros ordenados
        setRecords(sortedVisits);
        setFilteredRecords(sortedVisits);
        //obtener las empresas con los estados filtrados
        const uniqueCompanies = [...new Set(sortedVisits.map(record => record.companyName))];
        setFilteredCompanies(uniqueCompanies);

      } catch (error) {
        console.error("Error fetching visits:", error);
      } finally {
        setLoading(false); // Asegúrate de que loading se establezca en false aquí
      }
    };
  
    fetchVisits();
  }, []);

  const handleSearch = (value) => {
    setSearchTerm(value);
    const filtered = records.filter(record => {
      return Object.values(record).some(val =>
        String(val).toLowerCase().includes(value.toLowerCase())
      );
    });
    const finalFiltered = filtered.filter(record => {
      return showTable[record.estado] || showTable["Todos"];
    });
    setFilteredRecords(finalFiltered);
  };

  const handleFilterByPlaca = (value) => {
    setPlaca(value);
    const filtered = records.filter(record => record.plate.toLowerCase().includes(value.toLowerCase()));
    const finalFiltered = filtered.filter(record => {
      return showTable[record.estado] || showTable["Todos"];
    });
    setFilteredRecords(finalFiltered);
  };
  const handleFilterByEmpresa = (company) => {
    //console.log("Filtrando por empresa:", company);
    setSelectedCompany(company);
    const filtered = records.filter(record => record.companyName === company );
    const finalFiltered = filtered.filter(record => {
      return showTable[record.estado] || showTable["Todos"];
    });
    //console.log("Registros filtrados:", finalFiltered);
    setFilteredRecords(finalFiltered);
};

  const handleResetFilters = () => {
    setPlaca(""); 
    setSelectedCompany(""); 
    setSearchTerm("");
    setFilteredRecords(records);
    setFilteredRecords("");
    setShowTable({ 
      "Todos": false,
      "Agendado": false,
      "Entró": false,
      "Salió": false,
      "Retraso": false,
    });
  };

const [showTable, setShowTable] = useState({
  "Todos": true,
  "Agendado": false,
  "Entró": false,
  "Salió": false,
  "Retraso": false,
}); 
const handleToggleTable = (status) => {
  if (loading) return;
  setShowTable((prevState) => {
    const newState = { ...prevState };

    // Si el estado que se clickeó ya está visible, ocultarlo
    if (newState[status]) {
      newState[status] = false;
      setFilteredRecords(records); // Restablecer a todos los registros
      setNoRecords(records.length === 0);
    } else {
      // Ocultar todos los demás estados
      Object.keys(newState).forEach((key) => newState[key] = false);
      newState[status] = true;

      // Filtrar registros según el estado seleccionado
      if (status === "Todos") {
        setFilteredRecords(records); // Mostrar todos los registros
        setNoRecords(records.length === 0);
        const uniqueCompanies = [...new Set(records.map(record => record.companyName))]; // Obtener todas las empresas
        setFilteredCompanies(uniqueCompanies); 
       // console.log("Todos : ", (records))
      } else {
        const filtered = records.filter((record) => record.estado === status);
        setFilteredRecords(filtered); // Mostrar solo los registros que coinciden con el estado seleccionado
        //console.log("Filtrados:", filtered);
        setNoRecords(filtered.length === 0);
        const uniqueCompanies = [...new Set(filtered.map(record => record.companyName))];
        setFilteredCompanies(uniqueCompanies);
      }
    }
    return newState;
  });
};

const handleExportToExcel = () => {
  // Filtrar los registros según el estado visible
  let dataToExport = [];
  if (showTable["Todos"]) {
    dataToExport = filteredRecords; // Exportar todos los registros
  } else {
    // Exportar solo los registros que coinciden con el estado visible
    const visibleStatus = Object.keys(showTable).find(status => showTable[status]);
    if (visibleStatus) {
      dataToExport = filteredRecords.filter(record => record.estado === visibleStatus);
    }
  }

  // Mapear los datos a un formato adecuado para Excel
  const formattedData = dataToExport.map(record => ({
    id: record.id,
    Placa: record.plate,
    TipoVehículo: record.typeVehicle,
    Estado: record.estado,
    Conductor: record.driverName,
    Dni: record.dni,
    Empresa: record.companyName,
    FechaDeEntrada: record.startDateScheduled,
  }));

  const ws = XLSX.utils.json_to_sheet(formattedData);
  ws['A1'].v = 'ID';
  ws['B1'].v = 'Placa';
  ws['C1'].v = 'Tipo de Vehículo';
  ws['D1'].v = 'Estado';
  ws['E1'].v = 'Conductor';
  ws['F1'].v = 'Dni';
  ws['G1'].v = 'Empresa';
  ws['H1'].v = 'Fecha de visita';

  for (let i = 2; i <= formattedData.length + 1; i++) {
    ws[`A${i}`].s = { alignment: { horizontal: "left" } };
    ws[`B${i}`].s = { alignment: { horizontal: "left" } };
    ws[`C${i}`].s = { alignment: { horizontal: "left" } };
    ws[`D${i}`].s = { alignment: { horizontal: "left" } };
    ws[`E${i}`].s = { alignment: { horizontal: "left" } };
    ws[`F${i}`].s = { alignment: { horizontal: "left" } };
    ws[`G${i}`].s = { alignment: { horizontal: "left" } };
    ws[`H${i}`].s = { alignment: { horizontal: "left" } };
  }

  ws['!cols'] = [
    { wch: 10 }, //  (ID)
    { wch: 20 }, //  (Placa)
    { wch: 20 }, //  (TipoVehiculo)
    { wch: 20 }, //  (Estado)
    { wch: 20 }, //  (Conductor)
    { wch: 20 }, //  (Dni)
    { wch: 20 }, //  (Empresa)
    { wch: 20 }, //  (FechaEntrada)
  ];
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, ws, 'Visitas');
  //console.log("Datos a exportar:", dataToExport);

  XLSX.writeFile(workbook, 'visitas.xlsx');
};
const isExportDisabled = filteredRecords.length === 0;

  return (
    <div className='min-h-screen'>
     
      <div className=''>   
        <div className=''>
          <div className='flex flex-col items-start justify-center md:pt-4 pt-28 pb-7 '>
          {loading ? (
                <ContentLoader
                  viewBox="0 0 1200 100"
                  height="100%"
                  width="100%"
                  backgroundColor="#f3f3f3"
                  foregroundColor="#ecebeb"
                  speed={2}
                >
                  <rect x="0" y="0" width="29%" height="40" rx="5" ry="5" />
                  <rect x="30%" y="0" width="19%" height="40" rx="5" ry="5" />
                  <rect x="50%" y="0" width="22%" height="40" rx="5" ry="5" />
                  <rect x="73%" y="0" width="12%" height="40" rx="5" ry="5" />
                  <rect x="86%" y="0" width="10%" height="40" rx="5" ry="5" />              
                </ContentLoader>
              ) : (
                           
            <div className='flex flex-col w-full mb-6 space-y-3 lg:space-x-3 lg:space-y-0 lg:flex-row '>
              <div className='flex space-x-3'>
                
                <FilterInput
                  placeholder="Filtrar por placa"
                  value={placa}
                  onChange={(e) => handleFilterByPlaca(e.target.value)} 
                />
              </div>
              <div className='flex space-x-3'>
                <FilterButton
                    text="Filtrar por empresa"
                    options={filteredCompanies}
                    onSelect={handleFilterByEmpresa}
                    selectedOption={selectedCompany}
                />
                <ResetFiltersButton onClick={handleResetFilters}/>
                
              </div>
              <div>
                <ExportButton onClick={handleExportToExcel} disabled={isExportDisabled}/>
              </div>
             
            </div>
            
            )}
          {loading ? (
                <ContentLoader
                  viewBox="0 0 1200 455"
                               height="100%"
                               width="100%"
                               backgroundColor="#f3f3f3"
                               foregroundColor="#ecebeb"
                               className='sm:-mt-10'
                               speed={2} 
                             >
                              <rect x="0" y="0" width="14%" height="25" rx="5" ry="5" /> 
                              <rect x="98%" y="18" width="2%" height="10" rx="5" ry="5" />
                              <rect x="0" y="40" width="100%" height="5" rx="5" ry="5" /> 
                               <rect x="0" y="70" width="5%" height="30" rx="5" ry="5" /> 
                               <rect x="6%" y="70" width="12%" height="30" rx="5" ry="5" />
                               <rect x="19%" y="70" width="10%" height="30" rx="5" ry="5" /> 
                               <rect x="30%" y="70" width="14%" height="30" rx="5" ry="5" /> 
                               <rect x="45%" y="70" width="14%" height="30" rx="5" ry="5" /> 
                               <rect x="60%" y="70" width="14%" height="30" rx="5" ry="5" /> 
                               <rect x="75%" y="70" width="14%" height="30" rx="5" ry="5" /> 
                               <rect x="90%" y="70" width="10%" height="30" rx="5" ry="5" />
                               
                               <rect x="0" y="110" width="5%" height="30" rx="5" ry="5" /> 
                               <rect x="6%" y="110" width="12%" height="30" rx="5" ry="5" />
                               <rect x="19%" y="110" width="10%" height="30" rx="5" ry="5" /> 
                               <rect x="30%" y="110" width="14%" height="30" rx="5" ry="5" /> 
                               <rect x="45%" y="110" width="14%" height="30" rx="5" ry="5" /> 
                               <rect x="60%" y="110" width="14%" height="30" rx="5" ry="5" /> 
                               <rect x="75%" y="110" width="14%" height="30" rx="5" ry="5" /> 
                               <rect x="90%" y="110" width="10%" height="30" rx="5" ry="5" /> 
  
                               <rect x="0" y="170" width="14%" height="25" rx="5" ry="5" /> 
                              <rect x="98%" y="188" width="2%" height="10" rx="5" ry="5" />
                              <rect x="0" y="210" width="100%" height="5" rx="5" ry="5" /> 
  
                              <rect x="0" y="250" width="14%" height="25" rx="5" ry="5" /> 
                              <rect x="98%" y="258" width="2%" height="10" rx="5" ry="5" />
                              <rect x="0" y="290" width="100%" height="5" rx="5" ry="5" /> 
  
                              <rect x="0" y="330" width="14%" height="25" rx="5" ry="5" /> 
                              <rect x="98%" y="338" width="2%" height="10" rx="5" ry="5" />
                              <rect x="0" y="370" width="100%" height="5" rx="5" ry="5" /> 
  
                              <rect x="0" y="410" width="14%" height="25" rx="5" ry="5" /> 
                              <rect x="98%" y="418" width="2%" height="10" rx="5" ry="5" />
                              <rect x="0" y="450" width="100%" height="5" rx="5" ry="5" /> 
  
                               
                          
                </ContentLoader>
              ) : (
               
                  
            <div className='font-itcmedium space-y-4 text-[18px] w-full '>
              <button onClick={() => handleToggleTable("Todos")} className='flex items-center border-b border-[#808080] justify-between w-full'>
                <p className='text-[#007696] '>Todos</p>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.4401 6.13477H8.76756H4.56006C3.84006 6.13477 3.48006 7.00477 3.99006 7.51477L7.87506 11.3998C8.49756 12.0223 9.51006 12.0223 10.1326 11.3998L11.6101 9.92227L14.0176 7.51477C14.5201 7.00477 14.1601 6.13477 13.4401 6.13477Z" fill="#007696"/>
                </svg>
              </button>
              {showTable["Todos"] && (
                <>
                <SearchInput 
                  placeholder='Buscar' 
                  value={searchTerm}
                  onChange={handleSearch}
                />  
                  {filteredRecords.length === 0 ? (
                    <p className='text-xl text-center font-itcmedium'>No se hallaron registros.</p>
                  ) : (
                    <TableList
                    records={filteredRecords}
                    recordsPerPage={9}
                    onCurrentPageRecordsCountChange={() => {
                    }}
                    />
                  )}
                </>
              )}
              {["Agendado", "Entró", "Salió", "Retraso"].map((status, index) => (
                <React.Fragment key={index}>
                  <button
                    onClick={() => handleToggleTable(status)}
                    className="flex items-center border-b border-[#808080] justify-between w-full"
                  >
                    <p
                      className={
                        status === "Agendado"
                          ? "text-[#184A7D]"
                          : status === "Entró"
                          ? "text-green"
                          : status === "Salió"
                          ? "text-[#FFC700]"
                          : "text-[#B92A37]"
                      }
                    >
                      {status}
                    </p>
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.4401 6.13477H8.76756H4.56006C3.84006 6.13477 3.48006 7.00477 3.99006 7.51477L7.87506 11.3998C8.49756 12.0223 9.51006 12.0223 10.1326 11.3998L11.6101 9.92227L14.0176 7.51477C14.5201 7.00477 14.1601 6.13477 13.4401 6.13477Z"
                        fill={
                          status === "Agendado"
                            ? "#184A7D"
                            : status === "Entró"
                            ? "#77A042"
                            : status === "Salió"
                            ? "#FFC700"
                            : "#B92A37"
                        }
                      />
                    </svg>
                  </button>
                  {showTable[status] && (
                    // console.log("Registros pasados a TableList:", filteredRecords), // Verifica los registros que se pasan
                    <>
                    <SearchInput 
                  placeholder='Buscar' 
                  value={searchTerm}
                  onChange={handleSearch}
                />
                    {filteredRecords.length === 0 ? (
                      <p className='text-xl text-center font-itcmedium'>No se hallaron registros.</p>
                    ) : (
                      <TableList
                      records={filteredRecords}
                      recordsPerPage={9}
                      onCurrentPageRecordsCountChange={() => {
                      }}
                      />
                    )}
                    </>
                  )}
                </React.Fragment>
              ))}
              
            </div>
           
            )}
              
          </div>
         {/**  <Programate/>*/}
        </div>
      </div>
    </div>
  );
}
